if (!customElements.get('le-hero')) {
  customElements.define(
    'le-hero',
    class LeHero extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.le-hero__track');
        this.slides = Array.from(this.querySelectorAll('.le-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.pauseButton = this.querySelector('[data-hero-pause]');
        this.current = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.goTo(this.current - 1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.goTo(this.current + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.heroDot))));

        // The slide that is mostly visible is the current one (also after a swipe).
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setCurrent(this.slides.indexOf(entry.target));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reducedMotion;
        this.speed = Number(this.dataset.speed) || 7000;
        this.userPaused = false;

        if (this.dataset.autoplay === 'true' && reducedMotion) this.setUserPaused(true);

        this.pauseButton?.addEventListener('click', () => this.setUserPaused(!this.userPaused));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      setCurrent(index) {
        if (index < 0) return;
        this.current = index;
        this.dots.forEach((dot, i) => {
          if (i === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      goTo(index) {
        const total = this.slides.length;
        const target = (index + total) % total;
        const slide = this.slides[target];
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.setCurrent(target);
      }

      setUserPaused(paused) {
        this.userPaused = paused;
        this.classList.toggle('is-paused', paused);
        if (this.pauseButton) {
          this.pauseButton.setAttribute(
            'aria-label',
            paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel
          );
        }
        if (paused) {
          this.stop();
        } else {
          this.autoplay = this.dataset.autoplay === 'true';
          this.start();
        }
      }

      start() {
        if (!this.autoplay || this.userPaused || this.timer) return;
        this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  );
}
